/**
 * Tiny non-cryptographic 32-character hash (4 × 32-bit DJB2)
 * ------------------------------------------------------------------ */
const djb2_32 = (str: any, seed: any) => {
    let h = seed >>> 0;                       // force unsigned 32-bit
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h) ^ str.charCodeAt(i); // h * 33 ^ c
    }
    return h >>> 0;                           // keep as unsigned int
}

const hash32x4 = (str: any) => {
    const seeds = [5381, 52711, 61843, 69061];      // four different seeds
    return seeds
        .map(s => djb2_32(str, s).toString(16).padStart(8, '0'))
        .join('');                                   // 4 × 8  = 32 hex chars
}

/**
 * Synchronous version of the original createToken
 * ------------------------------------------------------------------ */
export function createToken(cookieName = 'BA_SESSION') {

    /* 1. read cookie ------------------------------------------------------ */
    const cookieVal = (() => {
        const kv = document.cookie
            .split(';')
            .map(s => s.trim())
            .find(s => s.startsWith(cookieName + '='));
        return kv ? decodeURIComponent(kv.split('=')[1]) : null;
    })();

    if (!cookieVal) return '';

    /* 2. epoch hour ------------------------------------------------------- */
    const epochHour = Math.floor(Date.now() / 3_600_000);  // 1 h = 3 600 000 ms

    /* 3. hash ------------------------------------------------------------- */
    const raw = `${cookieVal}:${epochHour}`;          // e.g. "123:461123"
    const hashHex = hash32x4(raw).slice(0, 32);           // keep first 32 hex

    /* 4. token ------------------------------------------------------------ */
    return `${epochHour}.${hashHex}`;                      // "461123.d4ab..."
}